import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["selected"]
  static targets = ["item"]

  connect() {
    const selected = this.element.querySelector(`.${this.selectedClasses[0]}`);
    if (!selected) return;

    const container = this.scrollContainer();
    if (!container) return;

    const offset = selected.offsetTop - container.offsetTop;
    container.scrollTop = offset - (container.clientHeight - selected.offsetHeight) / 2;
  }

  select(event) {
    event.preventDefault()

    this.itemTargets.forEach(item => {
      item.classList.remove(...this.selectedClasses)
      item.removeAttribute("aria-current")
    })
    event.currentTarget.classList.add(...this.selectedClasses)
    event.currentTarget.setAttribute("aria-current", "true")

    const href = event.currentTarget.href
    if (!href) return

    const target = new URL(href)
    target.search = new URL(window.location).search
    history.pushState({}, "", target)

    // Move focus into the detail region as soon as it swaps in (before the
    // mobile list panel is hidden) so assistive tech announces the selection.
    const request = turboStreamHandler.runRequest(href)
    if (request && typeof request.then === "function") {
      request.then(() => this.focusSelectedJob())
    } else {
      this.focusSelectedJob()
    }
  }

  focusSelectedJob() {
    const region = document.getElementById("selected_job")
    if (region) region.focus({ preventScroll: true })
  }

  scrollContainer() {
    let el = this.element;
    while (el && el !== document.body) {
      const overflowY = getComputedStyle(el).overflowY;
      if (overflowY === "auto" || overflowY === "scroll") return el;
      el = el.parentElement;
    }
    return null;
  }
}
